import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "animation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "c4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "c3" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "c2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "c1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 100 100",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    stroke: "#06DFF9",
    "stroke-width": "3",
    "stroke-miterlimit": "15",
    "stroke-dasharray": "14.2472,14.2472",
    cx: "50",
    cy: "50",
    r: "47"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "8s",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })
  ]),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    stroke: "#07A6C5",
    "stroke-width": "1",
    "stroke-miterlimit": "10",
    "stroke-dasharray": "10,10",
    cx: "50",
    cy: "50",
    r: "39"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "8s",
      from: "0 50 50",
      to: "-360 50 50",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "static"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "c4" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "c3" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "c2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "c1" }, null, -1)
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-cirlce", {animation: _ctx.type === 'animation'}]),
    ref: "circle"
  }, [
    (_ctx.type === 'animation')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_13))
  ], 2))
}